<template>
  <div id="new_user" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>企業情報入力</h2>
          <label>下記フォームより入力してください。</label>
        </div>
        <dd-corp-input
          ref="corpInput"
          :isEdit="true"
          :corpForm="corpForm"
          :isManager="true"
        />
        <div id="regist_btn">
          <button class="main_btn" @click="update()">更新する</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
// import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// import {CORP_TYPE, INFO_SRC} from '../constants/TypeEc'

// Module
import Header from '../components/common/DcHeader'
import CorpInput from '../components/user/CorpInput'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-corp-input': CorpInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      corpForm: {
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      isEdit: false,
      errors: {},
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        email: ''
      }
    }
  },
  computed: {
  },
  methods: {
    update: function () {
      let ret = this.$refs.corpInput.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        corpName: this.corpForm.corpName,
        corpBranchName: this.corpForm.corpBranchName,
        email: this.corpForm.email,
        tel: this.corpForm.tel,
        fax: this.corpForm.fax,
        postcd: this.corpForm.postcd,
        state: this.corpForm.state,
        city: this.corpForm.city,
        street: this.corpForm.street
      }
      axios.post(DC_URL.USER + '/update-corp', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.fieldErrorMessages.email = response.data.errorMessage
          this.$refs.corpInput.setErrorMessage(this.fieldErrorMessages)
        } else {
          // 更新データをストレージに格納する
          // App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
          App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
          this.$router.push({
            name: 'UpdateUserConfirm'
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    fetchData: function () {
      this.corpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdateCorpInput.vue